import { useEffect, useState, useRef } from 'react';

export const createSkeletonRows = (count = 2) => {
  return Array.from({ length: count }, (_, index) => ({
    id: `skeleton-${index}`,
    isSkeleton: true,
  }));
};

export const useTableContextChange = (props) => {
  const{
    contextValues,
    setIsFetchingMore,
    setRows,
    setRowData
  } = props;
  const previousContext = useRef(contextValues);
  const [hasContextChanged, setHasContextChanged] = useState(false);

  const handleContextChange = () => {
    setHasContextChanged(true);
    setIsFetchingMore(false);
    setRows([]);
    setRowData([]);
    resetContextChange();
  };

  const resetContextChange = () => setHasContextChanged(false);
  useEffect(() => {
    // initialization state
    const isInitializing = Object.values(contextValues).every(
      value => value === null || value === "" || value === undefined
    );

    // Check if previous context was for initialization
    const wasInitializing = Object.values(previousContext.current).every(
      value => value === null || value === "" || value === undefined
    );

    // Skip context change detection if we're initializing or were initializing
    if (isInitializing || wasInitializing) {
      previousContext.current = { ...contextValues };
      handleContextChange();
      return;
    }

    // Check for actual context changes
    const hasChanged = Object.keys(contextValues).some(
      key => contextValues[key] !== previousContext.current[key]
    );

    if (hasChanged) {
      handleContextChange();
      previousContext.current = { ...contextValues };
    } else {
      setHasContextChanged(false);
    }
  }, Object.values(contextValues));



  return { hasContextChanged, resetContextChange };
};

export const TABLE_ACTIONS = {
  DUPLICATE: 0,
};